import { render, staticRenderFns } from "./number.vue?vue&type=template&id=7a465495&scoped=true"
import script from "./number.vue?vue&type=script&lang=js"
export * from "./number.vue?vue&type=script&lang=js"
import style0 from "./number.vue?vue&type=style&index=0&id=7a465495&lang=css"
import style1 from "./number.vue?vue&type=style&index=1&id=7a465495&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a465495",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a465495')) {
      api.createRecord('7a465495', component.options)
    } else {
      api.reload('7a465495', component.options)
    }
    module.hot.accept("./number.vue?vue&type=template&id=7a465495&scoped=true", function () {
      api.rerender('7a465495', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/goods/components/number.vue"
export default component.exports